import executorFactory from './notifications/executor';
import executorProxy from './notifications/executors/executorProxy';
import { NotificationQueue } from './notifications/queue';

const actionsExecutor = executorFactory(executorProxy);

const Notifications = {
	queue: new NotificationQueue(actionsExecutor),

	init: function() {
		this.queue.resume();
	},

	destroy: function() {
		// Reset the queue so any in-flight executor timeouts (forceFullyEndTimeout,
		// afterDoneTimeout) don't re-trigger processing after the DOM has been cleared
		this.queue.reset();
		Screen.elements.notifications.html('');
	},

	addToQueue: function(notifications) {
		const id = notifications.map(p => p.id).join('#');
		this.queue.enqueue({
			id,
			parts: notifications,
		});
	},
};

export default Notifications;
